import React, { useState } from "react";
import { updateResellerMerchant } from "../../../config/LiveApi";
import { toast } from "react-toastify";

/* -------- Commission Normalizer -------- */
const normalizeCommission = (value) => {
  if (value === "" || value === null || value === undefined) return "";

  let num = String(value).trim();

  if (num.startsWith(".")) {
    num = "0" + num;
  }

  const parsed = parseFloat(num);

  if (isNaN(parsed)) return "";

  return parsed;
};

const ResellerMerchantEditModal = ({ merchant, token, onClose, onSuccess }) => {
  const [status, setStatus] = useState(merchant.status);
  const [payinComm, setPayinComm] = useState(merchant.payinCommission);
  const [payoutComm, setPayoutComm] = useState(merchant.payoutCommission);
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    try {
      const payin = normalizeCommission(payinComm);
      const payout = normalizeCommission(payoutComm);

      if (payin === "" || payout === "") {
        toast.error("Commission must be a valid number");
        return;
      }

      if (payin < 0 || payin > 100 || payout < 0 || payout > 100) {
        toast.error("Commission must be between 0 and 100");
        return;
      }

      setLoading(true);

      await updateResellerMerchant(
        {
          id: merchant.id,
          status: String(status),
          payinComm: String(payin),
          payoutComm: String(payout),
        },
        token,
      );

      toast.success("Reseller Merchant updated successfully");
      onSuccess();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update reseller merchant");
    } finally {
      setLoading(false);
    }
  };

  const handleInput = (setter) => (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setter(value);
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={header}>
          <h2 style={{ margin: 0 }}>Edit Merchant</h2>
          <button onClick={onClose} style={closeBtn}>
            ✕
          </button>
        </div>

        <div style={formGroup}>
          <label style={label}>Status</label>
          <select
            style={input}
            value={status}
            onChange={(e) => setStatus(Number(e.target.value))}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        <div style={formGroup}>
          <label style={label}>Payin Commission (%)</label>
          <input
            style={input}
            type="text"
            value={payinComm}
            placeholder="Enter payin commission"
            onChange={handleInput(setPayinComm)}
          />
        </div>

        <div style={formGroup}>
          <label style={label}>Payout Commission (%)</label>
          <input
            style={input}
            type="text"
            value={payoutComm}
            placeholder="Enter payout commission"
            onChange={handleInput(setPayoutComm)}
          />
        </div>

        <div style={buttonRow}>
          <button
            onClick={handleUpdate}
            disabled={loading}
            style={{
              ...primaryBtn,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Updating..." : "Save Changes"}
          </button>

          <button onClick={onClose} style={secondaryBtn}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

/* ---------------- Styles ---------------- */

const overlay = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.55)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  backdropFilter: "blur(4px)",
};

const modal = {
  background: "#ffffff",
  padding: "28px",
  borderRadius: "16px",
  width: "420px",
  maxWidth: "95%",
  boxShadow: "0 20px 45px rgba(0,0,0,0.15)",
};

const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
};

const closeBtn = {
  background: "transparent",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
  color: "#6b7280",
};

const formGroup = {
  display: "flex",
  flexDirection: "column",
  marginBottom: "18px",
};

const label = {
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "6px",
  color: "#374151",
};

const input = {
  padding: "10px 12px",
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  fontSize: "14px",
  outline: "none",
};

const buttonRow = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "10px",
};

const primaryBtn = {
  padding: "10px 18px",
  backgroundColor: "#fc8019",
  color: "#ffffff",
  border: "none",
  borderRadius: "8px",
  fontWeight: 600,
  marginRight: "10px",
};

const secondaryBtn = {
  padding: "10px 18px",
  backgroundColor: "#f3f4f6",
  color: "#374151",
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  fontWeight: 500,
  cursor: "pointer",
};

export default ResellerMerchantEditModal;
